import { render, staticRenderFns } from "./AppLoad.vue?vue&type=template&id=4a47f43b&scoped=true&"
import script from "./AppLoad.vue?vue&type=script&lang=js&"
export * from "./AppLoad.vue?vue&type=script&lang=js&"
import style0 from "./AppLoad.vue?vue&type=style&index=0&id=4a47f43b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a47f43b",
  null
  
)

export default component.exports